export default __webpack_public_path__ + "static/media/genji-ult.c69d24f0.mp3";